import { Locale } from '@enmon/commons';

import { csCZ } from './cs_CZ';
import { enUS } from './en_US';
import { plPL } from './pl_Pl';
import { skSK } from './sk_SK';

/*
 * AntD LanguageProvider locale map (frontend-only)
 * Exported via the `@enmon-monorepo/i18n/react` entry point, not the main one.
 */
export const ANTD_LOCALE_MAP = {
  [Locale.CS]: csCZ,
  [Locale.EN]: enUS,
  [Locale.PL]: plPL,
  [Locale.SK]: skSK,
} as const;
